import {lazy} from "react";

export const CamerasTableLazy = lazy(()=>import('./CamerasTable'))